import { colors } from '@atlaskit/theme';

export const LINE_COLOR_MAP = {
	development: colors.B200,
	testing: colors.T300,
	staging: colors.T500,
	prod: colors.B400,
	unmapped: colors.P200,
} as const;
